export default function Hero() {
  return (
    <section
      id="hero"
      className="relative w-full min-h-[600px] md:min-h-[720px] flex items-center overflow-hidden bg-background-50"
    >
      <div className="absolute inset-0 bg-gradient-to-br from-primary-50/40 via-background-50 to-accent-50/30" />
      <div className="absolute top-[-20%] right-[-10%] w-[600px] h-[600px] rounded-full bg-primary-100/20 blur-3xl" />
      <div className="absolute bottom-[-15%] left-[-5%] w-[500px] h-[500px] rounded-full bg-accent-100/15 blur-3xl" />

      <div className="relative z-10 w-full max-w-[1280px] mx-auto px-4 md:px-6 py-20 md:py-0">
        <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          <div className="flex-1 w-full text-center lg:text-left">
            <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-accent-100/70 text-accent-700 text-xs font-semibold mb-6">
              <i className="ri-flashlight-line" />
              <span>下拉滚动 · 流畅阅读</span>
            </div>

            <h1 className="font-heading text-3xl sm:text-4xl md:text-5xl lg:text-6xl text-foreground-950 leading-tight">
              汗汗漫画 · 下拉式漫画
              <br className="hidden sm:block" />
              连续阅读平台
            </h1>

            <p className="mt-4 text-lg md:text-xl text-primary-600 font-medium">
              滚动即阅读，一拉到底畅享漫画世界
            </p>

            <p className="mt-6 text-sm md:text-base text-foreground-600 leading-relaxed max-w-xl mx-auto lg:mx-0">
              汗汗漫画是专为漫画爱好者打造的下拉式连续阅读平台。告别传统翻页的割裂感，滚动即可无缝加载全话内容，让每一格分镜的节奏由你掌控。
              平台覆盖热血、恋爱、悬疑、奇幻等全品类漫画，每日更新上百话热门连载，更有智能缓存与跨设备进度同步功能——无论你在哪里、用什么设备，阅读体验始终流畅如一。
            </p>

            <div className="mt-8 flex flex-wrap items-center justify-center lg:justify-start gap-6 md:gap-8">
              <div className="text-center">
                <div className="text-2xl md:text-3xl font-heading text-primary-500">100+</div>
                <div className="text-xs text-foreground-500 mt-1">每日更新话数</div>
              </div>
              <div className="w-px h-10 bg-background-300 hidden sm:block" />
              <div className="text-center">
                <div className="text-2xl md:text-3xl font-heading text-accent-500">5000+</div>
                <div className="text-xs text-foreground-500 mt-1">收录漫画作品</div>
              </div>
              <div className="w-px h-10 bg-background-300 hidden sm:block" />
              <div className="text-center">
                <div className="text-2xl md:text-3xl font-heading text-primary-500">全免费</div>
                <div className="text-xs text-foreground-500 mt-1">无隐藏收费</div>
              </div>
            </div>

            <div className="mt-8 flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-4">
              <a
                href="#index"
                onClick={(e) => {
                  e.preventDefault();
                  document.querySelector('#index')?.scrollIntoView({ behavior: 'smooth' });
                }}
                className="inline-flex items-center gap-2 px-8 py-3.5 rounded-full bg-primary-500 text-background-50 font-semibold text-sm hover:bg-primary-600 transition-colors duration-200 whitespace-nowrap cursor-pointer"
              >
                <i className="ri-compass-3-line" />
                开始阅读
              </a>
              <a
                href="#features"
                onClick={(e) => {
                  e.preventDefault();
                  document.querySelector('#features')?.scrollIntoView({ behavior: 'smooth' });
                }}
                className="inline-flex items-center gap-2 px-8 py-3.5 rounded-full border-2 border-primary-300 text-primary-600 font-semibold text-sm hover:bg-primary-50 transition-colors duration-200 whitespace-nowrap cursor-pointer"
              >
                <i className="ri-information-line" />
                了解特色
              </a>
            </div>
          </div>

          <div className="flex-1 w-full max-w-[500px] lg:max-w-none">
            <div className="relative">
              <div className="absolute inset-0 bg-gradient-to-tr from-primary-400/20 via-accent-300/15 to-transparent rounded-2xl blur-xl" />
              <img
                src="https://readdy.ai/api/search-image?query=Artistic%20digital%20illustration%20of%20manga%20reading%20experience%2C%20floating%20comic%20panels%20with%20Japanese%20style%20artwork%20in%20warm%20orange%20coral%20and%20cream%20colors%2C%20continuous%20vertical%20scroll%20design%20concept%2C%20clean%20modern%20minimalist%20composition%2C%20soft%20gradient%20background%2C%20dynamic%20page%20flow%20effect%2C%20editorial%20quality%20with%20warm%20lighting&width=800&height=700&seq=hero-manga-main&orientation=portrait"
                alt="汗汗漫画下拉式连续阅读体验"
                title="汗汗漫画下拉式连续阅读体验"
                className="relative w-full h-auto rounded-2xl"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}